import React from 'react'
import GroupContractBuilderGeneral from './tabs/GroupContractBuilderGeneral.js'
import GroupContractBuilderPricing from './tabs/GroupContractBuilderPricing.js'
import GroupContractBuilderRates from './tabs/GroupContractBuilderRates.js'
import GroupContractBuilderNotes from './tabs/GroupContractBuilderNotes.js'
import GroupContractBuilderReservations from './tabs/GroupContractBuilderReservations.js'
class GroupContractBuilderTabContent extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="tab-content">
        <GroupContractBuilderGeneral {...this.props} />
        <GroupContractBuilderPricing {...this.props} />
        <GroupContractBuilderRates {...this.props} />
        <GroupContractBuilderNotes {...this.props} />
        {this.props.reservation ? <GroupContractBuilderReservations {...this.props} /> : null}
      </div>
    );
  }

};
export default GroupContractBuilderTabContent
